const STORAGE_KEY = 'sshop:cart-token';

const isBrowser = (): boolean =>
  typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';

export function getCartToken(): string | null {
  if (!isBrowser()) return null;
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value !== null && value !== '' ? value : null;
  } catch {
    return null;
  }
}

export function setCartToken(token: string): void {
  if (!isBrowser()) return;
  try {
    window.localStorage.setItem(STORAGE_KEY, token);
  } catch {
    /* ignore quota / privacy errors */
  }
}

export function clearCartToken(): void {
  if (!isBrowser()) return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
